import script from "./TermsOfServiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfServiceDialog.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfServiceDialog.vue?vue&type=style&index=0&id=fe05effa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe05effa"]])

export default __exports__